// @flow
import * as React from 'react';
import debounce from 'lodash.debounce';
import { parseISO } from 'date-fns';
import { isEmpty } from 'utils/functional';
import { stripTimezone } from 'utils/date';
import DateTimeLoadable from './DateTimeLoadable';

const disablePastDatesValidator = currentDate => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return currentDate.isAfter(yesterday.toDateString());
};

const DateTimePicker = ({
  value,
  onChange,
  hasError,
  disablePastDates,
  // `withoutTimezone`: Is this datepicker "timezone agnostic" (will call `onChange` with a datetime string without timezone)
  withoutTimezone,
  storeLocalTime,
  ...rest
}: {
  value: ?string,
  onChange: (?string) => void,
  hasError?: boolean,
  disablePastDates?: boolean,
  withoutTimezone?: boolean,
  storeLocalTime?: boolean
}) => {
  const datetimeProps = {
    ...rest,
    autoComplete: 'off'
  };
  const onChangeDebounced = debounce(onChange, 200);
  const parsedValue = value ? parseISO(value) : null;

  return (
    <DateTimeLoadable
      locale={USER_LOCALE}
      inputProps={datetimeProps}
      hasError={hasError}
      isValidDate={disablePastDates ? disablePastDatesValidator : null}
      value={parsedValue}
      onChange={selectedDate => {
        if (typeof selectedDate === 'string') {
          if (isEmpty(selectedDate)) {
            onChangeDebounced(null);
          }
        } else if (selectedDate.isValid() && selectedDate.year() > 2000) {
          onChangeDebounced(
            // Expression yields a formatted datetime string
            storeLocalTime
              ? selectedDate.format()
              : withoutTimezone
              ? stripTimezone(selectedDate.utcOffset(0, true).format())
              : selectedDate.utc().format()
          );
        } else {
          onChangeDebounced(null);
        }
      }}
    />
  );
};

export default DateTimePicker;
